import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PageDeleteService } from '../../services';
import { ToastResponse } from '../../utilities/ToastResponse';

export const fetchPageDelete = createAsyncThunk(
    'sliderGet/fetchPageDelete',
    async ({ id }) => {
        const response = await PageDeleteService(id)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
);

const pageDeleteSlice = createSlice({
    name: 'pageDelete',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPageDelete.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchPageDelete.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchPageDelete.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default pageDeleteSlice.reducer;
